export const company = {
  serviceName: 'Odaro Studio',
  domainDisplay: 'www.asystentremontowy.pl',
  domainHref: 'https://www.asystentremontowy.pl',
  formAction: 'https://formspree.io/f/mlgkrrez',
  legalName: 'Aram Arzumanian',
  nip: '8993046312',
  address:
    'woj. DOLNOŚLĄSKIE, pow. Wrocław, gm. Wrocław, miejsc. Wrocław, ul. Stanisława Worcella, nr 2, 50-448',
  email: 'odarostudio@gmail.com'
} as const;
